export const getMessageFromGQLError = (error: unknown): string | undefined => {
  if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') {
    return error.message;
  }
};
